import { CustomModal, Divider } from "@components"

import {
  Button, 
  ModalContent, 
  ModalHeader, 
  ModalBody, 
  ModalFooter,
} from "@heroui/react"

import PropTypes from 'prop-types'

const OpenToStaffModal = ({ 
  handleCancel, 
  handleOpenToStaff, 
  isOpeningToStaff,
  staffWithoutSBAccounts, 
  show 
}) => {  
  const closeModal = () => {
    handleCancel()
  }

  return (
    <CustomModal
      isOpen={show}
      size="xl"
      handleClose={closeModal}
      scrollBehavior="outside"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader>Open Event To Staff</ModalHeader>
          
            <ModalBody>
              <div>
                <h1 className="mt-2 text-lg font-semibold">Are you sure you want to open this event to staff?</h1>
                <p className="text-content2-foreground">{staffWithoutSBAccounts.length === 1 ? 'You have 1 staff member that has no SchoolBooking account.' : `You have ${staffWithoutSBAccounts.length} staff members that have no SchoolBooking account.`} If using SSO an account should be created on login. Otherwise you can link to an existing account from the Staff page. In either case we recommend clearing this list by manually linking or asking the member of staff to log into SchoolBooking (SSO) prior to continuing.</p>

                <Divider className="my-3" />

                {staffWithoutSBAccounts.length > 0 && (
                  <ul className="overflow-y-auto list-disc list-inside max-h-96">
                    {staffWithoutSBAccounts.map((staff) => (
                      <li key={staff.id}>{staff.forename} {staff.surname}</li>
                    ))}
                  </ul>
                )}
              </div>
            </ModalBody>

            <ModalFooter>
              <div className="flex justify-between w-full">
                <Button onPress={handleCancel} tabIndex={-1}>Cancel</Button>
                <Button className="font-semibold text-white" color="success" onPress={handleOpenToStaff} tabIndex={-1} isLoading={isOpeningToStaff}>Open To Staff</Button>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </CustomModal>
  )
}

OpenToStaffModal.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleOpenToStaff: PropTypes.func.isRequired,
  staffWithoutSBAccounts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    forename: PropTypes.string,
    surname: PropTypes.string,
  })),
  isOpeningToStaff: PropTypes.bool.isRequired,
  show: PropTypes.bool,
}

export default OpenToStaffModal